module.exports = {
  plus: [{
    text: 'Muito inadequado',
    score: 1,
    color: 1
  }, {
    text: 'Relativamente inadequado',
    score: 2,
    color: 2
  }, {
    text: 'Nem adequado, nem inadequado',
    score: 3,
    color: 3
  }, {
    text: 'Relativamente adequado',
    score: 4,
    color: 4
  }, {
    text: 'Muito adequado',
    score: 5,
    color: 5
  }],
  minus: [{
    text: 'Muito inadequado',
    score: 5,
    color: 1
  }, {
    text: 'Relativamente inadequado',
    score: 4,
    color: 2
  }, {
    text: 'Nem adequado, nem inadequado',
    score: 3,
    color: 3
  }, {
    text: 'Relativamente adequado',
    score: 2,
    color: 4
  }, {
    text: 'Muito adequado',
    score: 1,
    color: 5
  }]
};